/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AptosAddressSummaryInfo } from './AptosAddressSummaryInfo';
import type { AptosMarketplaceInfo } from './AptosMarketplaceInfo';

export type AptosNftActionInfo = {
    ACTTP: AptosNftActionInfo.ACTTP;
    ADDRSFROMINFO: AptosAddressSummaryInfo;
    ADDRSTOINFO: AptosAddressSummaryInfo;
    AMT: string;
    PRC: string;
    COLID: string;
    COLNM: string;
    TKNID: string;
    IMG: string;
    NM: string;
    MKPINFO: AptosMarketplaceInfo;
    FLD: string;
};

export namespace AptosNftActionInfo {

    export enum ACTTP {
        MINT = 'MINT',
        BURN = 'BURN',
        TRANSFER = 'TRANSFER',
        MUTATE = 'MUTATE',
        BIDDING = 'BIDDING',
        CANCEL_BIDDING = 'CANCEL_BIDDING',
        COLLECTION_BIDDING = 'COLLECTION_BIDDING',
        COLLECTION_CANCEL_BIDDING = 'COLLECTION_CANCEL_BIDDING',
        LISTING = 'LISTING',
        DELIST = 'DELIST',
        SOLD = 'SOLD',
        UPDATE_PRICE = 'UPDATE_PRICE',
    }


}

